export const FETCH_CHAINS = 'FETCH_CHAINS';
export const FETCH_CHAINS_SUCCESS = 'FETCH_CHAINS_SUCCESS';
export const SET_CHAINS = 'SET_CHAINS';
export const FETCH_CHAINS_FAILURE = 'FETCH_CHAINS_FAILURE';

export const FETCH_CHAIN = 'FETCH_CHAIN';
export const FETCH_CHAIN_SUCCESS = 'FETCH_CHAIN_SUCCESS';
export const FETCH_CHAIN_FAILURE = 'FETCH_CHAIN_FAILURE';

export const CREATE_CHAIN_REQUEST = 'CREATE_CHAIN_REQUEST';
export const CREATE_CHAIN = 'CREATE_CHAIN';
export const CREATE_CHAIN_SUCCESS = 'CREATE_CHAIN_SUCCESS';
export const CREATE_CHAIN_FAILURE = 'CREATE_CHAIN_FAILURE';

export const UPDATE_ACTIVE_CHAIN = 'UPDATE_ACTIVE_CHAIN';
export const UPDATE_ACTIVE_CHAIN_SUCCESS = 'UPDATE_ACTIVE_CHAIN_SUCCESS';
export const UPDATE_ACTIVE_CHAIN_FAILURE = 'UPDATE_ACTIVE_CHAIN_FAILURE';

export const SEND_MESSAGE = 'SEND_MESSAGE';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE';

export const FORWARD_MESSAGE = 'FORWARD_MESSAGE';
export const FORWARD_MESSAGE_SUCCESS = 'FORWARD_MESSAGE_SUCCESS';
export const FORWARD_MESSAGE_FAILURE = 'FORWARD_MESSAGE_FAILURE';

export const FORWARD_CHAIN = 'FORWARD_CHAIN';
export const FORWARD_CHAIN_SUCCESS = 'FORWARD_CHAIN_SUCCESS';
export const FORWARD_CHAIN_FAILURE = 'FORWARD_CHAIN_FAILURE';

export const LOAD_MESSAGES_PAGE = 'LOAD_MESSAGES_PAGE';
export const LOAD_MESSAGES_PAGE_SUCCESS = 'LOAD_MESSAGES_PAGE_SUCCESS';
export const LOAD_MESSAGES_PAGE_FAILURE = 'LOAD_MESSAGES_PAGE_FAILURE';

export const SET_MAIL_TEMPLATES_GROUPS = 'SET_MAIL_TEMPLATES_GROUPS';
export const SET_MAIL_TEMPLATES_GROUPS_SUCCESS =
  'SET_MAIL_TEMPLATES_GROUPS_SUCCESS';
export const SET_MAIL_TEMPLATES_GROUPS_FAILURE =
  'SET_MAIL_TEMPLATES_GROUPS_FAILURE';

export const SET_MAIL_TEMPLATES = 'SET_MAIL_TEMPLATES';
export const SET_MAIL_TEMPLATES_SUCCESS = 'SET_MAIL_TEMPLATES_SUCCESS';
export const SET_MAIL_TEMPLATES_FAILURE = 'SET_MAIL_TEMPLATES_FAILURE';

export const APPLY_CHAIN_COPILOT_SUGGESTION = 'APPLY_CHAIN_COPILOT_SUGGESTION';
export const DECLINE_CHAIN_COPILOT_SUGGESTION =
  'DECLINE_CHAIN_COPILOT_SUGGESTION';

export const SET_MAIL_TEMPLATE = 'SET_MAIL_TEMPLATE';
export const SET_MAIL_TEMPLATE_SUCCESS = 'SET_MAIL_TEMPLATE_SUCCESS';
export const SET_MAIL_TEMPLATE_FAILURE = 'SET_MAIL_TEMPLATE_FAILURE';

export const APPLY_MAIL_TEMPLATE = 'APPLY_MAIL_TEMPLATE';

export const SEARCH_MAIL_TEMPLATES = 'SEARCH_MAIL_TEMPLATES';
export const SEARCH_MAIL_TEMPLATES_SUCCESS = 'SEARCH_MAIL_TEMPLATES_SUCCESS';
export const SEARCH_MAIL_TEMPLATES_FAILURE = 'SEARCH_MAIL_TEMPLATES_FAILURE';
export const RESET_MAIL_TEMPLATES_SEARCH = 'RESET_MAIL_TEMPLATES_SEARCH';

export const SELECT_FOUND_MAIL_TEMPLATE = 'SELECT_FOUND_MAIL_TEMPLATE';
export const SELECT_FOUND_MAIL_TEMPLATE_SUCCESS =
  'SELECT_FOUND_MAIL_TEMPLATE_SUCCESS';

export const SET_CHAIN_BODY = 'SET_CHAIN_BODY';

export const ADD_MESSAGE_IN_CHAIN = 'ADD_MESSAGE_IN_CHAIN';
export const UPDATE_MESSAGE_IN_CHAIN = 'UPDATE_MESSAGE_IN_CHAIN';

export const CREATE_CHAIN_IN_CHAIN_LIST = 'CREATE_CHAIN_IN_CHAIN_LIST';
export const UPDATE_CHAIN_IN_CHAIN_LIST = 'UPDATE_CHAIN_IN_CHAIN_LIST';

export const LOAD_HISTORY_MESSAGES_IN_CHAIN = 'LOAD_HISTORY_MESSAGES_IN_CHAIN';
export const LOAD_HISTORY_MESSAGES_IN_CHAIN_SUCCESS =
  'LOAD_HISTORY_MESSAGES_IN_CHAIN_SUCCESS';
export const LOAD_HISTORY_MESSAGES_IN_CHAIN_FAILURE =
  'LOAD_HISTORY_MESSAGES_IN_CHAIN_FAILURE';
export const LOAD_HISTORY_MESSAGES_PAGE_SUCCESS =
  'LOAD_HISTORY_MESSAGES_PAGE_SUCCESS';

export const REVEAL_SERVICE_MESSAGES = 'REVEAL_SERVICE_MESSAGES';

export const SET_FORWARDING_MESSAGE = 'SET_FORWARDING_MESSAGE';
export const RESET_FORWARDING_MESSAGE = 'RESET_FORWARDING_MESSAGE';
export const SET_FORWARDING_MESSAGE_BODY = 'SET_FORWARDING_MESSAGE_BODY';

export const SET_FORWARDING_CHAIN = 'SET_FORWARDING_CHAIN';
export const RESET_FORWARDING_CHAIN = 'RESET_FORWARDING_CHAIN';

export const SET_CHAIN_COPILOT_SUGGESTIONS = 'SET_CHAIN_COPILOT_SUGGESTIONS';

export const fetchChains = () => ({ type: FETCH_CHAINS });
export const fetchChain = ({ id, history }) => ({
  payload: { id, history },
  type: FETCH_CHAIN,
});
export const createChainRequest = type => ({
  type: CREATE_CHAIN_REQUEST,
  payload: type,
});
export const createChain = ({
  history,
  subject,
  from,
  body,
  attachments,
  subjects,
  subjectsCopy,
  subjectsHideCopy,
}) => ({
  payload: {
    history,
    subject,
    body,
    from,
    attachments,
    subjects,
    subjectsCopy,
    subjectsHideCopy,
  },
  type: CREATE_CHAIN,
});
export const updateActiveChain = ({
  from,
  subject,
  subjectsCopy,
  subjectsHideCopy,
}) => ({
  payload: {
    from,
    subject,
    subjectsCopy,
    subjectsHideCopy,
  },
  type: UPDATE_ACTIVE_CHAIN,
});
export const sendMessage = ({
  body,
  from,
  imageUrl,
  attachments,
  subjects,
  subjectsCopy,
  subjectsHideCopy,
}) => ({
  payload: {
    body,
    attachments,
    imageUrl,
    from,
    subjects,
    subjectsCopy,
    subjectsHideCopy,
  },
  type: SEND_MESSAGE,
});

export const forwardMessage = ({
  messageId,
  subject,
  comment,
  body,
  from,
  imageUrl,
  attachments,
  forwardAttachments,
  subjects,
  subjectsCopy,
  subjectsHideCopy,
}) => ({
  payload: {
    messageId,
    subject,
    comment,
    body,
    attachments,
    forwardAttachments,
    imageUrl,
    from,
    subjects,
    subjectsCopy,
    subjectsHideCopy,
  },
  type: FORWARD_MESSAGE,
});

export const forwardChain = ({
  subject,
  chainId,
  to,
  from,
  comment,
  subjectsCopy,
  subjectsHideCopy,
}) => ({
  payload: {
    subject,
    chainId,
    to,
    from,
    comment,
    subjectsCopy,
    subjectsHideCopy,
  },
  type: FORWARD_CHAIN,
});

export const loadPageMessages = ({
  isNextPage,
  isRewriteMessages,
  isLastPage,
}) => ({
  payload: {
    isNextPage,
    isRewriteMessages,
    isLastPage,
  },
  type: LOAD_MESSAGES_PAGE,
});
export const loadHistoryMessages = ({ chainId }) => ({
  type: LOAD_HISTORY_MESSAGES_IN_CHAIN,
  payload: { chainId },
});
export const setMailTemplates = ({ groupId }) => ({
  type: SET_MAIL_TEMPLATES,
  payload: { groupId },
});
export const setMailTemplate = ({ templateId }) => ({
  type: SET_MAIL_TEMPLATE,
  payload: { templateId },
});
export const applyMailTemplate = ({ id, body, imageUrl }) => ({
  type: APPLY_MAIL_TEMPLATE,
  payload: { id, body, imageUrl },
});
export const searchMailTemplates = ({ query }) => ({
  type: SEARCH_MAIL_TEMPLATES,
  payload: { query },
});
export const resetMailTemplatesSearch = () => ({
  type: RESET_MAIL_TEMPLATES_SEARCH,
});
export const selectFoundMailTemplate = ({ templateId }) => ({
  type: SELECT_FOUND_MAIL_TEMPLATE,
  payload: { templateId },
});
export const setChainBody = ({ body }) => ({
  type: SET_CHAIN_BODY,
  payload: { body },
});
export const revealServiceMessages = ({ messageId }) => ({
  type: REVEAL_SERVICE_MESSAGES,
  payload: { messageId },
});
export const setForwardingMessage = payload => ({
  type: SET_FORWARDING_MESSAGE,
  payload,
});
export const resetForwardingMessage = () => ({
  type: RESET_FORWARDING_MESSAGE,
});
export const setForwardingChain = payload => ({
  type: SET_FORWARDING_CHAIN,
  payload,
});
export const resetForwardingChain = () => ({
  type: RESET_FORWARDING_CHAIN,
});
export const applyChainCopilotSuggestion = ({ id, text }) => ({
  payload: {
    id,
  },
  type: !!text
    ? APPLY_CHAIN_COPILOT_SUGGESTION
    : DECLINE_CHAIN_COPILOT_SUGGESTION,
});
